module.exports = __webpack_public_path__ + "static/media/dance.1277a673.svg";